interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}

enum HomepageBannerCTAValues {
    control = 'control',
    location = 'location',
}
export const HomepageBannerCTAExperiment: Experiment<
    typeof HomepageBannerCTAValues
> = {
    name: 'homepage_banner_cta',
    paramName: 'cta_string',
    values: HomepageBannerCTAValues,
};

export enum SearchCardInformationHierarchyExperimentValues {
    control = 'control',
    variant1 = 'variant1',
    variant2 = 'variant2',
    variant3 = 'variant3',
    variant4 = 'variant4',
    variant5 = 'variant5',
    variant6 = 'variant6',
}

export enum SearchCardInformationHierarchyExperimentConfig {
    name = 'search_event_card_information_hierarchy',
    paramName = 'search_card_type',
}

export const SearchCardInformationHierarchyExperiment: Experiment<
    typeof SearchCardInformationHierarchyExperimentValues
> = {
    name: SearchCardInformationHierarchyExperimentConfig.name,
    paramName: SearchCardInformationHierarchyExperimentConfig.paramName,
    values: SearchCardInformationHierarchyExperimentValues,
};

export interface SearchServerEnrolledExperiments {
    [SearchCardInformationHierarchyExperimentConfig.name]?: {
        [SearchCardInformationHierarchyExperimentConfig.paramName]: SearchCardInformationHierarchyExperimentValues;
    };
}
